module.exports = __webpack_public_path__ + "img/photo-11.768fef8a.webp";